// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Common Client V2 imports
const { keyedReviver } = require('client-v2/common/state/record-reviver')
// Model record imports
const ArticleModelRecord = require('client-v2/common/models/article/record')
const CollectionModelRecord = require('client-v2/common/models/collection/record')
const InterestModelRecord = require('client-v2/common/models/interest/record')
const PageContextRecord = require('client-v2/common/models/page-context/record')
const UserModelRecord = require('client-v2/common/models/user/record')
// Model reducer imports
const articleReducer = require('client-v2/common/models/article/reducer')
const interestReducer = require('client-v2/common/models/interest/reducer')
const collectionReducer = require('client-v2/common/models/collection/reducer')
const userReducer = require('client-v2/common/models/user/reducer')
// Sibling imports
const FeedItemMetaRecord = require('./item-meta')
const { wrapFeedItem } = require('../wrappers')

class FeedItemRecord extends Immutable.Record({
  article: null,
  collection: null,
  id: null,
  interest: null,
  meta: new FeedItemMetaRecord(),
  pageContext: null, // Only populated in denormalized form
  type: String(),
  user: null
}) {
  static fromJS(obj) {
    return Immutable.fromJS(obj, FeedItemRecord.reviver)
  }

  static fromModel(model) {
    return FeedItemRecord.fromJS(wrapFeedItem(model))
  }

  getModel() {
    switch (this.type) {
      case modelTypes.ARTICLE: return this.article
      case modelTypes.INTEREST: return this.interest
      case modelTypes.MIX: return this.collection
      case modelTypes.USER: return this.user
    }
  }

  denormalize(streamMeta, pageContextOverlay = {}) {
    const itemPageContext = streamMeta.getPageContextForFeedItem(this)
    return this.set('pageContext', itemPageContext.merge(pageContextOverlay))
  }

  reducer(action) {
    switch (this.type) {
      case modelTypes.ARTICLE:
        return this.update('article', article => {
          return articleReducer(article, action)
        })
      case modelTypes.INTEREST:
        return this.update('interest', interest => {
          return interestReducer(interest, action)
        })
      case modelTypes.MIX:
        return this.update('collection', collection => {
          return collectionReducer(collection, action)
        })
      case modelTypes.USER:
        return this.update('user', user => {
          return userReducer(user, action)
        })
      default:
        return this
    }
  }
}

FeedItemRecord.reviver = keyedReviver(FeedItemRecord, {
  article: ArticleModelRecord.reviver,
  collection: CollectionModelRecord.reviver,
  interest: InterestModelRecord.reviver,
  meta: FeedItemMetaRecord.reviver,
  pageContext: PageContextRecord.reviver,
  user: UserModelRecord.reviver
})

FeedItemRecord.propTypes = {
  article: PropTypes.shape(ArticleModelRecord.propTypes),
  collection: PropTypes.shape(CollectionModelRecord.propTypes),
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  interest: PropTypes.shape(InterestModelRecord.propTypes),
  meta: PropTypes.shape(FeedItemMetaRecord.propTypes),
  pageContext: PropTypes.shape(PageContextRecord.propTypes),
  type: PropTypes.string.isRequired,
  user: PropTypes.shape(UserModelRecord.propTypes)
}

module.exports = Object.assign(FeedItemRecord, {
  FeedItemMetaRecord
})
